if (!customElements.get("info-modal")) {
  class infoModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.modal = this.querySelector('.info-modal');
      this.apparitionDelay = this.modal.getAttribute('data-apparition-delay');
      this.showOnlyOnce = this.modal.getAttribute('data-show-only-online') === 'true';
      this.scrollPosition = window.scrollY || 0;
      this.closeModalButton = this.querySelector('.info-modal__close-btn');
      
      this.bindEvents();

      if (Shopify.designMode) {
        this.handleDesignMode();
        return;
      }

      if (this.showOnlyOnce && localStorage.getItem('infoModalShown')) return;

      setTimeout(() => this.openModal(), this.apparitionDelay);
    }

    handleDesignMode() {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.openModal();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) {
          this.closeModal();
        }
      });
    }

    bindEvents() {
      this.modal.addEventListener('click', (e) => this.handleModalClick(e));
      document.addEventListener('keydown', (e) => this.handleKeydown(e));
    }

    handleModalClick(event) {
      const target = event.target;
      if (target === this.modal || target === this.closeModalButton) {
        this.closeModal();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.closeModal();
      }
    }

    openModal() {
      this.modal.showModal();
      this.scrollPosition = window.scrollY;
      this.bodyLock(true);

      if (this.showOnlyOnce) {
        localStorage.setItem('infoModalShown', 'true');
      }
    }

    closeModal() {
      this.modal.close();
      this.bodyLock(false);
    }

    bodyLock(value) {
      const body = document.body;

      if (value) {
        body.style.top = `-${this.scrollPosition}px`;
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.width = "100%";
        return;
      }

      body.style.removeProperty("overflow");
      body.style.removeProperty("position");
      body.style.removeProperty("width");
      body.style.removeProperty("top");

      window.scrollTo(0, this.scrollPosition);
    }
  }

  customElements.define("info-modal", infoModal);
}
